import { apiCall } from "../imports"

const PREFIX = "shop/promotions"

export default {

    getPromotions(data) {
        return apiCall('get', `${PREFIX}`, data)
    },

    findPromotion(promotionID) {
        return apiCall('get', `${PREFIX}/${promotionID}`)
    },

    createPromotion(data) {
        return apiCall('post', `${PREFIX}`, data)
    },

    updatePromotion(promotionID, data) {
        return apiCall('post', `${PREFIX}/${promotionID}/update`, data)
    },

    deletePromotion(promotionID) {
        return apiCall('delete', `${PREFIX}/${promotionID}`)
    },

    getPromotionProducts(promotionID){
        return apiCall('get', `${PREFIX}/${promotionID}/products`)
    },

    addProductToPromotion(promotionID,data){
        return apiCall('post', `${PREFIX}/${promotionID}/products`, data)
    },

    deleteProductFromPromotion(promotionID,productID){
        return apiCall('delete', `${PREFIX}/${promotionID}/products/${productID}`)
    }
}